export const ErrorMessage = (error, message, addToast) => {
  if (
    error &&
    error.response &&
    error.response.data &&
    Object.keys(error.response.data.errors).length > 0
  ) {
    Object.keys(error.response.data.errors).map((item) => {
      return addToast(`[${item}] => ${error.response.data.errors[item][0]}`, {
        appearance: "error",
      });
    });
  } else {
    return addToast(error?.response?.data?.message || message, {
      appearance: "error",
    });
  }
};
